import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { TonConnectUIProvider } from '@tonconnect/ui-react';
import App from './App';
import './styles.css';

function cleanEnvUrl(value: string | undefined): string | undefined {
  const trimmed = value?.trim();
  if (!trimmed || trimmed.includes('your-domain.pages.dev')) return undefined;
  return trimmed;
}

const manifestUrl =
  cleanEnvUrl(import.meta.env.VITE_MANIFEST_URL) ||
  `${window.location.origin}/tonconnect-manifest.json`;

const twaReturnUrl = (cleanEnvUrl(import.meta.env.VITE_APP_URL) || window.location.origin) as `${string}://${string}`;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <TonConnectUIProvider manifestUrl={manifestUrl} actionsConfiguration={{ twaReturnUrl }}>
      <App />
    </TonConnectUIProvider>
  </React.StrictMode>,
);
